<template>
  <div class="patient-table">
    <div v-if="unfinishedCheckState == 4">
      <el-input clearable v-model="search.patientName" style="width: 150px;margin-right: 15px;margin-bottom: 10px;" placeholder="请输入姓名" ></el-input>
      <el-input clearable v-model="search.admitNo" style="width: 150px;margin-right: 15px;margin-bottom: 10px;" placeholder="请输入住院号"></el-input>
      <el-select clearable v-model="search.followupStatus" placeholder="请选择随访状态" style="width: 200px;margin-right: 15px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in followUpStatus" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button @click="getAllList" type="primary">检索</el-button>
      <el-button @click="resetAllList">重置</el-button>
    </div>
<!--    全部-->
    <el-table
        :border="true"
        :data="tableData"
        v-if="unfinishedCheckState==4"
        v-loading="tableloaded"
    >
      <el-table-column prop="userName" label="姓名" width="170">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.userName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="admitNo" label="住院号">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.admitNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpDays" label="已拨叫天数">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.followUpDays}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpDate" label="最后拨打时间">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.followUpDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followupStatus" label="随访状态">
      </el-table-column>
      <el-table-column prop="groupName" label="标签分组">
      </el-table-column>
      <el-table-column prop="address" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="reCallAll(scope.row)">拨打</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 异常随访 -->
    <el-table
      :border="true"
      :data="tableData"
      v-if="unfinishedCheckState==1"
      v-loading="tableloaded"
    >
      <el-table-column prop="userName" label="姓名" width="170">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.userName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="admitNo" label="住院号">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.admitNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpDays" label="已拨叫天数">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.followUpDays}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpDate" label="最后拨打时间">
        <template slot-scope="scope">
          <span :class="{'time-out': scope.row.todayCalled}">{{scope.row.followUpDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="reCall('3',scope.row)">拨打</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 稍后拨打 -->
    <el-table
      :border="true"
      :data="tableData"
      v-if="unfinishedCheckState==2"
      v-loading="tableloaded"
    >
      <el-table-column prop="userName" label="姓名" width="170"></el-table-column>
      <el-table-column prop="admitNo" label="住院号"></el-table-column>
      <el-table-column prop="laterCallTime" label="预约时间">
        <template slot-scope="scope">
          <span :class="{'time-out': !scope.row.timeout}">{{scope.row.laterCallTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="followUpDate" label="最后拨打时间"></el-table-column>
      <el-table-column prop="address" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="reCall('4',scope.row)">拨打</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 需复核 -->
    <el-table
      :border="true"
      :data="tableData"
      v-if="unfinishedCheckState==5"
      v-loading="tableloaded"
    >
      <el-table-column prop="userName" label="姓名" width="170"></el-table-column>
      <el-table-column prop="admitNo" label="住院号"></el-table-column>
      <el-table-column prop="reviewPoolTime" label="需复核时间"></el-table-column>
      <el-table-column prop="followUpDate" label="最后拨打时间"></el-table-column>
      <el-table-column prop="address" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="reCall('8',scope.row)">拨打</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 收藏夹 -->
    <el-table
      :border="true"
      :data="filetableData"
      v-if="unfinishedCheckState==3"
      v-loading="tableloaded"
    >
      <el-table-column v-for="(col,index) in tableColumns" 
      :prop="col.value" 
      :label="col.label" 
      :key="index" 
      ></el-table-column>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="collectReCall(scope.row)">拨打</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top:10px;">
      <el-pagination
        background
        layout=" prev, pager, next"
        :page-count="totalPage"
        @current-change="currentChange"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList
} from "@src/assets/js/api.js";
import { mapGetters } from "vuex";
export default {
  name: "PatientTable",
  props: ["unfinishedCheckState","fileId"],
  data() {
    return {
      search: {
        patientName: null,
        admitNo: null,
        followupStatus: null,
      },
      followUpStatus:  [
        {label: '稍后呼叫', value: 8},
        {label: '异常号码', value: 13},
      ],
      tableloaded: false,
      pageSize: 10,
      totalPage: 1,
      currentPage: 1,
      tableData: [],
      returnFileId: this.fileId,
      filetableData: [],
      tableColumns:[
        {value:'patientName', label:'姓名'},
        {value:'admitNo', label:'住院号'},
        {value:'callDate', label:'最后一次拨打时间'},
        {value:'callDayNum', label:'已拨打天数'},
        {value:'sourceStr', label:'来源'},
      ],
      followupSourceDict: {
        1: 3,
        2: 4,
        3: 1
      }
    };
  },
  computed: {
    ...mapGetters(["userid", "getTaskCenterId"])
  },
  watch: {
    fileId: {
      handler(val) {
        this.currentPage = 1;
        this.returnFileId = val
        this.getExceptionPatient()
      }
    },
    unfinishedCheckState: {
      handler(val) {
        this.currentPage = 1;
        if (val == 1) {
          this.getAbnormalList()
        }else if(val == 2){
          this.getAfterCallList();
        }else if(val == 4) {
          this.getAllList()
        }
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.unfinishedCheckState == 1) {
      vm.getAbnormalList()
    }else if(vm.unfinishedCheckState == 2){
      vm.getAfterCallList();
    }else if(vm.unfinishedCheckState == 4) {
      vm.getAllList()
    }else if(vm.unfinishedCheckState == 5) {
      vm.getReviewFollowupList();
    }else {
      vm.getExceptionPatient()
    }
  },
  methods: {

    reCallAll(params) {
      if (params.groupName == "需复核") {
        this.reCall(-1,params,'8')
      }else if(params.followupStatus == '异常号码') {
        this.reCall(-1,params,'4')
      }else if(params.followupStatus == '稍后呼叫') {
        this.reCall(-1,params,'3')
      }else {
        this.collectReCall(params)
      }
      // this.reCall(-1,params)
    },
    reCall(num, params,isAll) {
      console.log("params",params)
      
      this.$emit('aliyunLogin',() => {
        //num: 3异常患者处理  4稍后随访   8 需复核 — 7收藏夹 6今日完成 5质控看板
        this.$router.push({
          path: "/callPatient",
          query: {
            pageIndex: this.currentPage,
            isAll: isAll || null,
            abnormal: num, 
            followUpPatientInfoId: params.followUpPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            index: params.index,
            followupSource: this.followupSourceDict[`${this.unfinishedCheckState}`],
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
          }
        });
      })
    },
    collectReCall(params){
      console.log("params",params)
      console.log("currentPage",this.currentPage)
      this.$emit('aliyunLogin',() => {
        this.$router.push({
          path: "/callPatient",
          query: {
            abnormal: 7, //收藏夹
            collectSource: params.source,
            followUpPatientInfoId: params.followupPatientInfoId,
            followupPatientId: params.followupPatientId,
            diseaseId: this.$route.query.diseaseId,
            patientId: params.patientId,
            followupSource: 1,
            index: params.index,
            isRemindStudy: this.$route.query.isRemindStudy,
            isSingleDuration: this.$route.query.isSingleDuration,
            isTotalDuration: this.$route.query.isTotalDuration,
            tabIndex: this.returnFileId,
            pageIndex: this.currentPage,
          }
        });
      })
    },
    currentChange(page) {
      this.currentPage = page;
      if (this.unfinishedCheckState == 1) {
        this.getAbnormalList()
      }else if(this.unfinishedCheckState == 2){
        this.getAfterCallList();
      }else if(this.unfinishedCheckState == 4){
        this.getAllList();
      }else if(this.unfinishedCheckState == 5){
        this.getReviewFollowupList();
      }else {
        this.getExceptionPatient()
      }
    },
    getAbnormalList() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      };
      this.tableloaded = true;
      this.getAbnormalFollowupListAsync(params).then(res => {
        this.totalPage = res.totalPage;
        this.currentPage = res.page;
        this.tableloaded = false;
        this.tableData = res.retValue.map(item => {
          item.followUpDate?item.todayCalled = this.compareDate(item.followUpDate):item.todayCalled = false
          return item
        });
        console.log('this.tableData',this.tableData)
      });
      // 获取表格
    },
    getAfterCallList() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: this.currentPage,
        pageSize: this.pageSize,

      };
      this.tableloaded = true;
      this.getCallLaterFollowupListAsync(params).then(res => {
        this.totalPage = res.totalPage;
        this.currentPage = res.page;
        this.tableloaded = false;
        this.tableData = res.retValue.map(item => {
          //timeout: false未到预约时间(预约时间置灰)
          item.timeout = this.compareTime(item.laterCallTime)
          return item;
        })
      });
    },
    resetAllList() {
      this.search.admitNo = ""
      this.search.patientName = ""
      this.search.followupStatus = ""
      this.getAllList()
    },
    getAllList() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        admitNo: this.search.admitNo || null,
        patientName: this.search.patientName || null,
        followupStatus: this.search.followupStatus || null,
      };
      this.tableloaded = true;
      this.asyncGetPatientInfoList(params)
          .then( res => {
            this.totalPage = res.totalPage;
            this.currentPage = res.page;
            this.tableloaded = false;
            this.tableData = res.retValue.map(item => {
              //timeout: false未到预约时间(预约时间置灰)
              item.timeout = this.compareTime(item.laterCallTime)
              return item;
            })
          })
    },
    getReviewFollowupList() {
      this.tableloaded = true;
      this.$store.dispatch('requestHandler',{
        fn: "RestNewFollowupCallCenterServiceGetReviewFollowupTaskPatientInfoList",
        params: {
          userId: this.userid,
          followupTaskId: this.getTaskCenterId,
          pageIndex: this.currentPage,
          pageSize: 10,
        }
      }).then(res => {
        if (res.status == 0) {
          this.totalPage = res.totalPage;
          this.currentPage = res.page;
          this.tableloaded = false;
          this.tableData = res.retValue
        }else {
          this.tableData = []
          this.tableloaded = false;
        }
      })
    },
    async asyncGetPatientInfoList(p) {
      let result = await this.$store.dispatch('requestHandler',{
        fn: 'RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList',
        params: {
          userId: p.userId,
          followupTaskId: p.followupTaskId,
          admitNo: p.admitNo,
          patientName: p.patientName,
          followupStatus: p.followupStatus,
          pageIndex: this.currentPage,
          pageSize: 10,
        }
      })
      return result
    },
    // 比较时间
    compareTime(gettime) {
      let today = new Date(); //获取当前时间
      gettime = gettime.replace(/-/g, "/");
      let endTime = new Date(gettime); //自己的时间
      if (today.getTime() > endTime.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    compareDate(gettime) {
      var year = new Date().getFullYear()
      var month = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
      var day = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()
      let today = `${year}-${month}-${day}`
      let date = gettime.split(' ')[0]
      if (today==date) {
        return true;
      } else {
        return false;
      }
    },
    getExceptionPatient(){
      console.log("returnFileId",this.returnFileId);
      this.tableloaded = true
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestAbnormalFollowupFileControllerGetExceptionPatient',
          params: {
            seatId:this.userid,
            taskId:this.getTaskCenterId,
            fileId: this.returnFileId,
            pageIndex: this.currentPage,
            pageSize: 10
          }
        }
      ).then(res => {
        this.tableloaded = false
        if (res.status==0 && res.retValue.length>0) {
          this.filetableData= res.retValue
          this.totalPage = res.totalPage;
          this.currentPage = res.page;
        }else {
          this.filetableData = []
          this.totalPage = 1;
          this.currentPage = 1;
        }
      })
    },
    // ==============================================
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
.el-table__cell {
  color: #000;
  .time-out {
  color: #a7a7a7;
}
}
</style>
